<div class="accessibility-settings-area">
  <div class="slide-area">
    <div class="slide-area-label"
         id="accessibility-heading"
         [@accessibilityMenu]="menuState === 'visible' ? 'visible' : 'hidden'">
      <span>DOSTĘPNOŚĆ</span>
    </div>
    <button class="slide-area-icon-container"
            [@slideIcon]="iconState"
            (@slideIcon.start)="onClickShow()"
            [attr.aria-expanded]="menuState === 'visible'"
            aria-controls="accessibility-menu"
            aria-label="Menu dostępności"
            tabindex="0"
            (keydown.enter)="onClickShow()"
            (keydown.space)="onClickShow()">
      <img class="icon" [src]="'assets/icons/common/accessibility-settings.svg'" alt="Menu dostępności" aria-hidden="true"/>
    </button>
  </div>
  <div class="accessibility-menu"
       role="menu"
       id="accessibility-menu"
       [@accessibilityMenu]="menuState === 'visible' ? 'visible' : 'hidden'">
    <div class="accessibility-menu-item">
      <button class="accessibility-menu-item"
              (click)="toggleContrast()"
              role="menuitem"
              tabindex="0"
              aria-labelledby="contrast-change"
              aria-controls="accessibility-menu">
        <img class="accessibility-menu-item-img" [src]="'assets/icons/' + (brand$ | async) + '/eye.svg'" alt="Przycisk zmiany kontrastu" aria-hidden="true">
        <span id="contrast-change" class="accessibility-menu-item-span">Zmień kontrast</span>
      </button>
    </div>
    <div class="accessibility-menu-item">
      <a class="accessibility-menu-item"
         [attr.href]="(barrierFreeInfo() | async)"
         rel="noopener"
         target="_blank"
         role="link"
              tabindex="0"
         aria-label="Obsługa bez barier - przejście do strony"
              aria-controls="accessibility-menu">
        <img class="accessibility-menu-item-img" [src]="'assets/icons/' + (brand$ | async) + '/wheelchair.svg'" alt="Przycisk obsługa bez barier" aria-hidden="true">
        <span class="accessibility-menu-item-span">Obsługa bez barier</span>
      </a>
    </div>
  </div>
</div>
